export default {
  byUpdatedAt(a, b) {
    if (a.updated_at > b.updated_at) {
      return -1
    } else if (a < b) {
      return 1
    }
    return 0
  },
  sortOrder(a, b) {
    if (a.sort_order < b.sort_order) {
      return -1
    } else if (a > b) {
      return 1
    }
    return 0
  },
}

export const duration = (minutes) => {
  const h = Math.floor(minutes / 60)
  const min = Math.ceil(minutes % 60)
  if (h) {
    return `${h}h ${min}min`
  }
  if (min) {
    return `${min}min`
  }
  return null
}
